import { useApp } from '../store.js';

/** Окно «Турнирный билет»: купить за монеты; не хватает — сколько нужно (и путь в Training Center). */
export function TicketModal() {
  const modal = useApp((s) => s.ticketModal);
  const me = useApp((s) => s.me);
  const buy = useApp((s) => s.buyTicket);
  const play = useApp((s) => s.play);
  const close = useApp((s) => s.closeTicketModal);
  const setView = useApp((s) => s.setView);
  if (!modal || !me) return null;
  const { price } = me.tickets;
  const enough = me.coins >= price;

  return (
    <div className="overlay ticket-modal" role="dialog" aria-label="Турнирный билет">
      <div className="ticket-modal__icon" aria-hidden="true">
        🎟
      </div>
      {modal.bought ? (
        <>
          <p>Билет готов!</p>
          <button type="button" className="play play--small" onClick={() => void play(modal.size)}>
            Играть турнир на {modal.size}
          </button>
        </>
      ) : enough ? (
        <>
          <p>Турнирный билет ×1</p>
          <p className="overlay__hint">
            Цена: {price} 🪙 · у вас {me.coins} 🪙
          </p>
          <button type="button" className="play play--small" onClick={() => void buy()}>
            Купить за {price} 🪙
          </button>
        </>
      ) : (
        <>
          <p>Не хватает серебра</p>
          <p className="overlay__hint">
            Нужно: {price} 🪙 · у вас {me.coins} 🪙
          </p>
          <button
            type="button"
            className="play play--small"
            onClick={() => {
              close();
              useApp.setState({ trainingSource: 'not_enough_coins' });
              setView('training');
            }}
          >
            🏋️ Тренируйся и зарабатывай
          </button>
          <p className="overlay__hint">или сыграйте бесплатно: 1 на 1 и с друзьями</p>
        </>
      )}
      <button type="button" className="link" onClick={close}>
        {modal.bought ? 'Позже' : 'Закрыть'}
      </button>
    </div>
  );
}
